import React, { useEffect, useRef, useState } from "react";
import "./EditarClasseEstaleiroModal.css";

const sanitizeTextInput = (value, max = 80) =>
  String(value ?? "")
    .replace(/[\u0000-\u001F\u007F]/g, "")
    .replace(/[<>]/g, "")
    .toUpperCase()
    .slice(0, max);

const sanitizeTextSave = (value, max = 80) => sanitizeTextInput(value, max).trim();

export default function EditarClasseEstaleiroModal({ open, registro, onClose, onSalvar }) {
  const [classe, setClasse] = useState("");
  const [subClasse, setSubClasse] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const classeRef = useRef(null);

  useEffect(() => {
    if (!open) return;
    setClasse(sanitizeTextInput(registro?.classe || ""));
    setSubClasse(sanitizeTextInput(registro?.sub_classe || ""));
    setBusy(false);
    setErr("");
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    const t = setTimeout(() => classeRef.current?.focus(), 0);
    return () => {
      clearTimeout(t);
      document.body.style.overflow = prev;
    };
  }, [open, registro]);

  if (!open) return null;

  async function handleSalvar() {
    if (busy) return;
    setBusy(true);
    setErr("");
    try {
      const classeValue = sanitizeTextSave(classe);
      const subClasseValue = sanitizeTextSave(subClasse);
      if (!classeValue) throw new Error("Informe a classe.");
      await onSalvar?.({ classe: classeValue, subClasse: subClasseValue });
      onClose?.();
    } catch (e) {
      setErr(e?.response?.data?.error || e?.message || "Falha ao salvar alteracoes.");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="fbeed-overlay" onClick={onClose}>
      <div className="fbeed-card" onClick={(e) => e.stopPropagation()} role="dialog" aria-modal="true" aria-label="Editar classe">
        <div className="fbeed-head">
          <h3 className="fbeed-title">Editar Classe</h3>
          <button className="fbeed-close" type="button" onClick={onClose} disabled={busy} aria-label="Fechar">
            x
          </button>
        </div>

        <div className="fbeed-body">
          <label className="fbeed-field">
            <span>Classe</span>
            <input
              ref={classeRef}
              type="text"
              value={classe}
              onChange={(e) => setClasse(sanitizeTextInput(e.target.value))}
              autoComplete="off"
            />
          </label>
          <label className="fbeed-field">
            <span>Sub-classe (opcional)</span>
            <input
              type="text"
              value={subClasse}
              onChange={(e) => setSubClasse(sanitizeTextInput(e.target.value))}
              autoComplete="off"
            />
          </label>
          {err ? <div className="fbeed-error">{err}</div> : null}
        </div>

        <div className="fbeed-foot">
          <button className="fbeed-btn fbeed-btn-ghost" type="button" onClick={onClose} disabled={busy}>
            Cancelar
          </button>
          <button className="fbeed-btn fbeed-btn-primary" type="button" onClick={handleSalvar} disabled={busy}>
            {busy ? "Salvando..." : "Salvar alteracoes"}
          </button>
        </div>
      </div>
    </div>
  );
}
